import React from 'react';
import { Link } from 'react-router-dom';
import Stats from '../components/Stats';

/**
 * Dashboard est une page qui affiche le tableau de bord de l'administrateur.
 * Elle contient des liens vers d'autres pages d'administration, comme la gestion des utilisateurs et la création d'une URL de création de compte.
 * Elle contient également un lien vers le Back Office ReducCe.
 * Les liens sont créés en utilisant le composant Link de 'react-router-dom'.
 *
 * 
 */

const Dashboard = () => {
    return (
        <div className="min-h-screen bg-gray-50 py-8 px-4">
            <div className="max-w-6xl mx-auto">
                <div className="mb-8">
                    <h1 className="text-4xl font-bold text-theme-primary mb-4">
                        Bienvenue sur la page d'accueil de l'administrateur
                    </h1>
                    <p className="text-gray-600 text-lg">
                        Gérez votre application depuis ce tableau de bord
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                    <div className="card-theme group hover:shadow-lg transition-all duration-300">
                        <div className="flex items-center mb-4">
                            <div className="bg-theme-primary text-white p-3 rounded-lg mr-4">
                                <i className="fas fa-users text-xl"></i>
                            </div>
                            <h3 className="text-xl font-semibold text-theme-primary">Gestion des utilisateurs</h3>
                        </div>
                        <p className="text-gray-600 mb-4">
                            Gérez les comptes utilisateurs, leurs permissions et leurs informations.
                        </p>
                        <Link 
                            to="/admin/users" 
                            className="btn-theme w-full group-hover:bg-theme-primary-active transition-colors"
                        >
                            <i className="fas fa-arrow-right mr-2"></i>
                            Accéder à la gestion
                        </Link>
                    </div>

                    <div className="card-theme group hover:shadow-lg transition-all duration-300">
                        <div className="flex items-center mb-4">
                            <div className="bg-theme-accent text-white p-3 rounded-lg mr-4">
                                <i className="fas fa-link text-xl"></i>
                            </div>
                            <h3 className="text-xl font-semibold text-theme-primary">Création d'URL</h3>
                        </div>
                        <p className="text-gray-600 mb-4">
                            Créez des URLs personnalisées pour l'inscription des utilisateurs.
                        </p>
                        <Link 
                            to="/admin/CreateSignupPage" 
                            className="btn-theme w-full group-hover:bg-theme-primary-active transition-colors"
                        >
                            <i className="fas fa-arrow-right mr-2"></i>
                            Créer une URL
                        </Link>
                    </div>

                    <div className="card-theme group hover:shadow-lg transition-all duration-300">
                        <div className="flex items-center mb-4">
                            <div className="bg-theme-primary text-white p-3 rounded-lg mr-4">
                                <i className="fas fa-shopping-cart text-xl"></i>
                            </div>
                            <h3 className="text-xl font-semibold text-theme-primary">Commandes</h3>
                        </div>
                        <p className="text-gray-600 mb-4">
                            Consultez les commandes synchronisées avec le système.
                        </p>
                        <Link 
                            to="/commandes" 
                            className="btn-theme w-full group-hover:bg-theme-primary-active transition-colors"
                        >
                            <i className="fas fa-arrow-right mr-2"></i>
                            Voir les commandes
                        </Link>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                    <div className="card-theme group hover:shadow-lg transition-all duration-300">
                        <div className="flex items-center mb-4">
                            <div className="bg-green-600 text-white p-3 rounded-lg mr-4">
                                <i className="fas fa-cogs text-xl"></i>
                            </div>
                            <h3 className="text-xl font-semibold text-theme-primary">Back Office ReducCe</h3>
                        </div>
                        <p className="text-gray-600 mb-4">
                            Accédez au back office principal de ReducCe pour la gestion avancée.
                        </p>
                        <a 
                            href="https://admin.reducce.fr/login?returnUrl=%2Fadministrators" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="btn-theme-secondary w-full group-hover:bg-theme-primary-active transition-colors"
                        >
                            <i className="fas fa-external-link-alt mr-2"></i>
                            Ouvrir ReducCe
                        </a>
                    </div>

                    <div className="card-theme group hover:shadow-lg transition-all duration-300">
                        <div className="flex items-center mb-4">
                            <div className="bg-purple-600 text-white p-3 rounded-lg mr-4">
                                <i className="fas fa-envelope text-xl"></i>
                            </div>
                            <h3 className="text-xl font-semibold text-theme-primary">App Brevo</h3>
                        </div>
                        <p className="text-gray-600 mb-4">
                            Gérez vos campagnes email et votre base de contacts.
                        </p>
                        <a 
                            href="https://app.brevo.com/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="btn-theme-secondary w-full group-hover:bg-theme-primary-active transition-colors"
                        >
                            <i className="fas fa-external-link-alt mr-2"></i>
                            Ouvrir Brevo
                        </a>
                    </div>

                    <div className="card-theme group hover:shadow-lg transition-all duration-300">
                        <div className="flex items-center mb-4">
                            <div className="bg-indigo-600 text-white p-3 rounded-lg mr-4">
                                <i className="fas fa-chart-line text-xl"></i>
                            </div>
                            <h3 className="text-xl font-semibold text-theme-primary">Historique des connexions</h3>
                        </div>
                        <p className="text-gray-600 mb-4">
                            Consultez l'historique des connexions sur 48 mois pour les KPIs direction.
                        </p>
                        <Link 
                            to="/admin/connection-history" 
                            className="btn-theme w-full group-hover:bg-theme-primary-active transition-colors"
                        >
                            <i className="fas fa-arrow-right mr-2"></i>
                            Voir l'historique
                        </Link>
                    </div>

                    <div className="card-theme group hover:shadow-lg transition-all duration-300">
                        <div className="flex items-center mb-4">
                            <div className="bg-orange-600 text-white p-3 rounded-lg mr-4">
                                <i className="fas fa-envelope-open-text text-xl"></i>
                            </div>
                            <h3 className="text-xl font-semibold text-theme-primary">Changements d'email</h3>
                        </div>
                        <p className="text-gray-600 mb-4">
                            Consultez les changements d'email effectués par les utilisateurs et les administrateurs.
                        </p>
                        <Link 
                            to="/admin/email-changes" 
                            className="btn-theme w-full group-hover:bg-theme-primary-active transition-colors"
                        >
                            <i className="fas fa-arrow-right mr-2"></i>
                            Voir les changements
                        </Link>
                    </div>
                </div>

                <div className="card-theme">
                    <h2 className="text-2xl font-bold text-theme-primary mb-6">Statistiques</h2>
                    <Stats />
                </div>
            </div>
        </div>
    );
};

export default Dashboard;